<template>
	<div  class="pages-result__img-col">
		<div class="pages-result__icon">
			<span class="icon-document"></span>
		</div>
	</div>
</template>

<script lang="ts">
export default {
	name: "Literature",
};
</script>
